<template>
  <q-card
    flat
    class="q-pa-sm full-width no-padding-md"
    style="max-width: 100vw"
  >
    <q-card-section class="row q-pb-xs text-green-vito justify-between">
      <div class="text-h5">
        {{ $t("title.changes") }}
      </div>
      <div class="q-gutter-x-md row items-center">
        <q-input
          filled
          v-model="fromDate"
          mask="date"
          label="Début"
          :rules="['date']"
        >
          <template v-slot:append>
            <q-icon name="event" class="cursor-pointer">
              <q-popup-proxy
                cover
                transition-show="scale"
                transition-hide="scale"
              >
                <q-date v-model="fromDate">
                  <div class="row items-center justify-end">
                    <q-btn v-close-popup label="Close" color="primary" flat />
                  </div>
                </q-date>
              </q-popup-proxy>
            </q-icon>
          </template>
        </q-input>
        <q-input
          filled
          v-model="toDate"
          mask="date"
          label="Fin"
          :rules="['date']"
        >
          <template v-slot:append>
            <q-icon name="event" class="cursor-pointer">
              <q-popup-proxy
                cover
                transition-show="scale"
                transition-hide="scale"
              >
                <q-date v-model="toDate">
                  <div class="row items-center justify-end">
                    <q-btn v-close-popup label="Close" color="primary" flat />
                  </div>
                </q-date>
              </q-popup-proxy>
            </q-icon>
          </template>
        </q-input>
        <q-input
          outlined
          dense
          clearable
          debounce="300"
          v-model="filter"
          style="width: 150px"
          :placeholder="$t('label.search')"
        >
          <template v-slot:append>
            <q-icon name="search" />
          </template>
        </q-input>
        <download-excel :data="report" :fields="export_fields">
          Export <br />excel
        </download-excel>
      </div>
    </q-card-section>

    <q-card-section>
      <q-table
        :rows="report"
        :columns="columnsI18n"
        row-key="id"
        :pagination="pagination"
        :loading="loading"
        :filter="filter"
        binary-state-sort
        wrap-cells="true"
        class="sticky-header-table"
      >
        <template v-slot:header-cell="props">
          <q-th :props="props">
            {{ props.col.label }}
            <q-tooltip>{{ $t(`tooltip.${props.col.name}`) }}</q-tooltip>
          </q-th>
        </template>
        <template v-slot:body-cell-actions="props">
          <q-td :props="props">
            <div class="q-gutter-x-sm">
              <q-btn
                icon="visibility"
                square
                round
                dense
                @click="viewDetail(props.row)"
              >
                <q-tooltip class="bg-blue-btz text-no-wrap">
                  {{ $t("tooltip.viewScript") }}
                </q-tooltip>
              </q-btn>
            </div>
          </q-td>
        </template>
      </q-table>
    </q-card-section>
  </q-card>
  <q-dialog v-model="showDetail" ref="showDetailDialog">
    <report-log-detail-card
      @refresh="refresh"
      :startDate="selectedRow.day"
      :store="selectedRow.store.code"
    />
  </q-dialog>
</template>
<script>
import ReportApi from "../apis/Report";
import { useI18n } from "vue-i18n";
import { date } from "quasar";
import moment from "moment";
import ReportLogDetailCard from "../components/report/ReportLogDetailCard.vue";

export default {
  name: "ScriptsPage",

  components: { ReportLogDetailCard },
  setup() {
    const { locale } = useI18n({ useScope: "global" });
    return {
      locale,
    };
  },
  data: () => {
    return {
      action: "list",
      showNew: false,
      showDetail: false,
      filter: "",
      fromDate: moment().subtract(10, "d").toISOString(),
      toDate: moment().subtract(1, "d").toISOString(),
      loading: false,
      export_fields: [],
      report: [],
      perPage: 50,
      pagination: {
        sortBy: "id",
        descending: false,
        page: 1,
        rowsPerPage: 50,
      },
    };
  },
  watch: {
    fromDate: function () {
      this.getReport();
    },
    toDate: function () {
      this.getReport();
    },
  },
  methods: {
    async getReport() {
      this.loading = true;
      try {
        const reportReponse = await ReportApi.getChangesReport(
          this.fromDate,
          this.toDate
        );

        this.report = reportReponse.data;
        this.loading = false;
        //
      } catch (error) {
        const message = error.response
          ? error.response.data.message
          : error.message;
        this.errorMessage = message;
        this.$q.notify({
          type: "negative",
          message: message,
        });
      }
    },
    async viewDetail(row) {
      this.showDetail = true;
      console.log(row);
      this.selectedRow = row;
    },
    async refresh() {
      this.showNew = false;
      this.showDetail = false;
      await this.getReport();
    },
    get_excel_fields() {
      return {
        Id: "id",
        PDV: {
          callback: (row) => row.store.code,
        },
        Ville: {
          callback: (row) => row.store.city,
        },
        Nom: {
          callback: (row) => row.store.name,
        },
        Mandataire: {
          callback: (row) => row.store.agent,
        },
        Date: "day",
        "Num case vide en READY": "numEmpty",
        "Dont porte ouverte": "numEmptyWithDoorOpen",
        "Suspicion de vol": "numTheft",
        "Suspicion de vol (30 derniers jours)": "numTheftLast30Days",
        "Case en zippotage": "numLockerWithChanges",
      };
    },
  },

  async mounted() {
    this.$store.state.title = "button.changes";
    await this.getReport();
    this.export_fields = this.get_excel_fields();
  },

  computed: {
    columnsI18n() {
      const columns = [
        {
          name: "id",
          required: true,
          label: this.$t("label.id"),
          align: "left",
          field: "id",
          headerClass: "cursor-help",
          headerStyle: "position: relative",
          headerSlot: true,
        },
        {
          name: "code",
          required: true,
          label: this.$t("label.code"),
          align: "left",
          field: (row) => row.store.code,
          sortable: true,
          headerClass: "cursor-help",
          headerStyle: "position: relative",
          headerSlot: true,
        },
        {
          name: "city",
          required: true,
          label: this.$t("label.city"),
          field: (row) => row.store.city,
          align: "left",
          sortable: true,
          headerClass: "cursor-help",
          headerStyle: "position: relative",
          headerSlot: true,
        },
        {
          name: "name",
          required: true,
          label: this.$t("label.name"),
          field: (row) => row.store.name,
          align: "left",
          sortable: true,
          headerClass: "cursor-help",
          headerStyle: "position: relative",
          headerSlot: true,
        },
        {
          name: "agent",
          required: true,
          label: this.$t("label.agent"),
          field: (row) => row.store.agent,
          align: "left",
          sortable: true,
          headerClass: "cursor-help",
          headerStyle: "position: relative",
          headerSlot: true,
        },
        {
          name: "date",
          required: true,
          label: this.$t("label.refill_date"),
          format: (val) => date.formatDate(new Date(val), "DD-MM-YYYY HH:mm"),
          field: "day",
          align: "left",
          sortable: true,
          headerClass: "cursor-help",
          headerStyle: "position: relative",
          headerSlot: true,
        },
        {
          name: "numEmpty",
          label: this.$t("label.numEmpty"),
          field: "numEmpty",
          align: "left",
          sortable: true,
          headerClass: "cursor-help",
          headerStyle: "position: relative",
          headerSlot: true,
        },
        {
          name: "numEmptyWithDoorOpen",
          required: true,
          label: this.$t("label.numEmptyWithDoorOpen"),
          field: "numEmptyWithDoorOpen",
          align: "left",
          sortable: true,
          headerClass: "cursor-help",
          headerStyle: "position: relative",
          headerSlot: true,
        },
        {
          name: "numTheft",
          required: true,
          label: this.$t("label.numTheft"),
          field: "numTheft",
          align: "left",
          sortable: true,
          headerClass: "cursor-help",
          headerStyle: "position: relative",
          headerSlot: true,
        },
        {
          name: "numTheftLast30Days",
          required: true,
          label: this.$t("label.numTheftLast30Days"),
          field: "numTheftLast30Days",
          align: "left",
          sortable: true,
          headerClass: "cursor-help",
          headerStyle: "position: relative",
          headerSlot: true,
        },
        {
          name: "numLockerWithChanges",
          required: true,
          label: this.$t("label.numLockerWithChanges"),
          field: "numLockerWithChanges",
          align: "left",
          sortable: true,
          headerClass: "cursor-help",
          headerStyle: "position: relative",
          headerSlot: true,
        },
        {
          name: "actions",
          required: true,
          label: this.$t("label.action"),
          style: "width:70px",
        },
      ];
      return columns;
    },
  },
};
</script>
